export default __webpack_public_path__ + "media/images/theme/wordmark_light-cd54c04f76c3ceed7e35cf05d538ff5a.png";